import moment from "moment";
import Name from 'models/name';
import Comment from 'models/comment';

const GREENCOPPER_APP_MAP = {
	'greencopper_ios_id': 'iphone',
	'greencopper_android_id': 'android',
};

export class Address {
	constructor({
		address,
		city,
		count,
		country,
		checked,
		last_seen: lastSeen,
		zip_code: zipCode,
	} = {}) {
		this._street = address;
		this._city = city;
		this._count = count || 0;
		this._country = country;
		this._checked = checked || false;
		this._lastseen = lastSeen || null;
		this._zip_code = zipCode;
	}

	get street() {
		return this._street;
	}

	get city() {
		return this._city;
	}

	get country() {
		return this._country;
	}

	// eslint-disable-next-line camelcase
	get zip_code() {
		return this._zip_code;
	}

	isVerified() {
		return Boolean(this._checked);
	}

	hasExistingValues() {
		return Boolean(this._street || this._zip_code || this._city || this._country);
	}

	toString() {
		return `${this._street || ""} ${this._zip_code || ""} ${this._city || ""} ${this._country || ""}`;
	}
}

/**
 * Contact's model
 * @param {Array} birthdates - Array with birthdates
 * @param {Array} contact_addresses - The adresses of contact
 * @param {Object} email - The data with email
 * @param {Object} green_copper_id - Object with green_copper_id's data
 * @param {number} id - Id of the contact
 * @param {Object} infos - Data infos like first_name or last_name
 * @param {Object} phone - Data of the phones
 * @constructor
 */
export default class Contact {
	constructor({
		birthdates = [],
		email,
		contact_addresses: contactAddresses = [],
		green_copper_id: greenCopperId,
		id,
		gender,
		infos,
		phone,
		images,
		contact_id: contactId,
		comments = [],
		subscriptions=[],
		modified,
		language,
		root,
		custom_attributes: customAttributes,
		functions,
		created
	} = {}) {
		this._id = id;
		this._contact_id = contactId;
		this._comments = comments.map((com) => {
			return new Comment(com);
		});
		this._birthdate = birthdates[0] || null;
		this._contactAddress = new Address(contactAddresses[0]);
		this._gender = gender || {};
		this._greenCopperId = greenCopperId || null;
		this._email = email || null;
		this._phone = phone || null;
		this._image = (images && images[0]) || null;
		this._subscriptions = subscriptions;
		this._infos = infos || {};
		this._name = new Name(this._infos && this._infos.first_name, this._infos && this._infos.last_name);
		this._modified = modified;
		this._root = root || null;
		this._customAttributes = customAttributes || [];
		// Boby used to return a list of language in the language key and will
		// return a single object, keep it compatible both ways
		if (language instanceof Array) {
			language = language[0];
		}

		this._language = language || {};
		this._functions = functions || [];
		this._created = created;
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	getRoot() {
		return this._root;
	}

	getContactId() {
		return this._contact_id;
	}

	/* ADDRESSES */
	/**
	 * Retrieve address
	 * Availables fields { address, city, count, country, last_seen, zip_code}
	 * @returns {Object} - The formated address
	 */
	getAddress() {
		return this._contactAddress;
	}

	/* BIRTHDATES */
	getBirthDate() {
		return this._birthdate && this._birthdate.birthdate;
	}

	getAge() {
		return this._birthdate && moment().diff(this._birthdate.birthdate, "years", false);
	}

	/* GREENCOPPER */
	getDeviceType() {
		if (!this._greenCopperId) {
			return null;
		}
		return GREENCOPPER_APP_MAP[this._greenCopperId.application] || this._greenCopperId.application || '?';
	}

	getGreenCopper() {
		return this._greenCopperId;
	}

	/* PERSONAL DATA */
	getEmail() {
		return this._email && this._email.email;
	}

	isEmailBouncing() {

		return Boolean(this._email && this._email.bouncing);
	}

	isEmailRejected() {
		return Boolean(this._email && this._email.rejected);
	}

	_getSubscription(media) {
		return this._subscriptions.find(s => s.media === media) || {};
	}

	hasOptin(media='mail') {
		return this._getSubscription(media).optin || false;
	}

	hasSubscribed(media='mail') {
		return this._getSubscription(media).subscribed || false;
	}

	getGender() {
		return (this._gender && this._gender.gender) || "na";
	}

	/* PHONES */
	getPhoneNumber() {
		return this._phone && this._phone.number_text;
	}

	/* IMAGE */
	getImage() {
		return this._image ? this._image.image : null;
	}

	getName() {
		return this._name;
	}

	getModified() {
		return this._modified;
	}

	getComments() {
		return this._comments;
	}

	getLanguage() {
		return this._language.language;
	}

	getCustomAttributes = () => this._customAttributes;

	getMainFunction = () => this._functions[0] ? this._functions[0]["name"] : null;

	getFunctions = () => this._functions;

	getCreated = () => this._created;
}
